export const convertToTableData = (data) => {
  return (
    data?.results?.map((item) => {
      const teachingData = (item.json?.teaching || []).map((course, index) => ({
        key: course.id || index,
        name: Number(course?.name),
        credit: course?.credit,
        course_name: course?.course_name,
        course_code: course?.course_code,
        section: course?.section,
        score: course?.score,
        attachment: course?.attachments || course?.attachment
      }));

      const supervisionData = (item.json?.supervision || []).map(
        (course, index) => ({
          key: course.id || index,
          name: Number(course?.name),
          no_student: course?.no_student,
          section: course?.section,
          attachment: course?.attachments || course?.attachment
        })
      );

      const semester = item.semester || 'Unknown';

      return {
        id: item.id,
        semester: semester,
        semester_name: `Semester ${semester}`,
        apa_point: item?.apa_point,
        status: item.status,
        comment: item.comment,

        teaching: teachingData,
        supervision: supervisionData,

        // Snapshots of the fetched values, used to detect unsaved edits
        // (compared against live `teaching` / `supervision` in Semester.jsx)
        originalTeaching: teachingData,
        originalSupervision: supervisionData,
        underload: item?.json?.underload || null
      };
    }) || []
  );
};

export const convertToRequestData = (
  planing,
  selectedYear,
  formId,
  semester
) => {
  const semesterPlan =
    (planing?.length > 0 &&
      planing.find((plan) => plan.semester === semester)) ||
    {};

  return {
    apa_form: formId,
    year: selectedYear,
    semester: semester,
    json: {
      teaching: (semesterPlan?.teaching || []).map((course, index) => ({
        key: course.id || index,
        name: Number(course?.name),
        credit: course?.credit,
        course_name: course?.course_name,
        course_code: course?.course_code,
        section: course?.section,
        score: course?.score,
        attachments: course?.attachment || []
      })),
      supervision: (semesterPlan?.supervision || []).map((course, index) => ({
        key: course.id || index,
        name: Number(course?.name),
        no_student: course?.no_student,
        section: course?.section,
        attachments: course?.attachment || []
      }))
    }
  };
};

// Bootstraps evaluation records from Planning data the first time a semester
// has no evaluation record yet. Reads teaching/supervision directly since
// the Planning side (1.1) already stores semesters in this shape.
export const convertPlanningToRequestData = (planning, year, formId, courseType=[]) => {
    const isWaiverCourse = (name) => {
    const matched = courseType.find((item) => item.value === Number(name));
    return matched?.label?.toLowerCase?.() === 'course waiver';
  };

  return planning.map((semesterPlan) => ({
    apa_form: formId,
    year: year,
    semester: semesterPlan?.semester,
    apa_point: 10,
    no_planning: false,
    json: {
      teaching: (semesterPlan.teaching || []).map((course, index) => ({
        key: course.id || index,
        name: course?.name,
        credit: course?.credit || 0,
        course_name: course?.course_name || '',
        course_code: course?.course_code || '',
        section: course?.section || 0,
        score: isWaiverCourse(course?.name) ? 3 : (course?.score || 0),
        attachments: []
      })),
      supervision: (semesterPlan.supervision || []).map((course, index) => ({
        key: course.id || index,
        name: course?.name,
        no_student: course?.no_student,
        section: course?.section || 0,
        attachments: []
      }))
    }
  }));
};
